import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { StartupService } from '../service/startup.service';

import { ErrorHandlingService } from '../service/error-handling.service';
import { CONSTANTS } from 'src/app/config/constants.module';
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StartupResolver {
  private _ngRouteParams: any;

  constructor(
    private _startupService: StartupService,
    private _errorHandlingService: ErrorHandlingService,
    private _router: Router,
    @Inject(CONSTANTS) private _CONST: any
  ) {
    this._ngRouteParams = this.getParam(location.href);
  }

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    try {
      const fullfilledStartup = await this._startupService.start();

      if (this._ngRouteParams[this._CONST.APP_URL_PARAMS.PARAMETER_NAMES.FUNCTION]) {
        route.params = this._ngRouteParams;
      }
      if (fullfilledStartup.status === 200) {
        return true;
      } else {
        throw fullfilledStartup;
      }
    } catch (error) {
      this._errorHandlingService.errors.push(error);
      this._router.navigate(['/error']);
      return EMPTY;
    }
  }

  /**
   * @function getParam
   * @param url
   * @description get params from url in the correct format
   */
  private getParam(url) {
    const formattedParams: any = {};
    const option = url.split('?');
    if (option.length > 1) {
      const params = option[1].split('&');
      params.forEach(param => {
        const p = param.split('=');
        formattedParams[p[0]] = p[1];
      });
    }
    return formattedParams;
  }
}
